/**
 * 权限控制配置
 * 使用PermissionService进行统一权限管理
 */

import { LEGACY_ROLES, PERMISSION_GROUPS, ROLES } from '@/config/roles';
import { PermissionService } from '@/services/n8n/permission';

export default function access(initialState: any) {
  const { currentUser } = initialState ?? {};

  // 获取用户角色信息（支持多角色）
  const isAuthenticated = !!currentUser;
  const userEmail = currentUser?.email;

  // 角色标准化处理 - 支持多角色
  const normalizedRoles: readonly string[] = (
    currentUser?.role_codes ??
    (currentUser?.role_code ? [currentUser.role_code] : [])
  ).map((role: string) => (role === 'YunYing' ? LEGACY_ROLES.YunYing : role));

  // 辅助函数：检查用户的任意角色是否在权限组中
  const hasAnyRole = (group: readonly string[]) =>
    normalizedRoles.some((role: string) => group.includes(role));

  return {
    // 超级管理员权限
    canAdmin: normalizedRoles.includes(ROLES.SUPER_ADMIN),

    // 运营人员权限
    canOperator: hasAnyRole(PERMISSION_GROUPS.OPERATOR),

    // 积分管理权限
    canPointsManager: normalizedRoles.includes(ROLES.SUPER_ADMIN),

    // 用户管理权限
    canUserManager: normalizedRoles.includes(ROLES.SUPER_ADMIN),

    // 数据分析权限 - 仅限DATA_ANALYST角色和SUPER_ADMIN
    canDataAnalyst: hasAnyRole(PERMISSION_GROUPS.DATA_ANALYST),

    // 模型管理权限 - 仅限CONTENT_MANAGER角色和SUPER_ADMIN，或指定邮箱白名单
    canModelManager:
      hasAnyRole(PERMISSION_GROUPS.CONTENT_MANAGER) ||
      userEmail === 'model@snapmaker.com',

    // 基础访问权限
    canAccess: isAuthenticated,

    // 普通用户权限
    canUser:
      isAuthenticated &&
      normalizedRoles.length > 0 &&
      hasAnyRole(PERMISSION_GROUPS.USER),

    // 动态权限检查函数
    checkPermission: async (permissionCode: string) => {
      if (!userEmail || !isAuthenticated) return false;

      try {
        const users = await PermissionService.getUsers();
        const userInfoList = users.filter((user) => user.email === userEmail);

        if (userInfoList.length === 0) return false;

        // 超级管理员拥有所有权限
        if (userInfoList.some((u) => u.role_code === ROLES.SUPER_ADMIN))
          return true;

        // 检查所有角色的权限并集
        return userInfoList.some((u) => u.permissions.includes(permissionCode));
      } catch (error) {
        console.error('Permission check failed:', error);
        return false;
      }
    },
  };
}
